import { PhoneCall } from 'lucide-react';
import { useT } from '../../i18n';

export function LoginHero({ clinic, doctor }: { clinic: string; doctor: string }) {
  const t = useT();
  return (
    <section className="relative hidden overflow-hidden bg-sc-deep px-14 py-14 text-white lg:flex lg:flex-col lg:justify-between" data-testid="login-hero">
      <div className="sc-arcs pointer-events-none absolute -bottom-40 -right-40 h-[34rem] w-[34rem]" />
      <div className="relative">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-teal-200/70">Suraksha Sathi</p>
      </div>
      <div className="relative max-w-lg">
        <p className="font-hindi text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">{t('login.heroHi')}</p>
        <p className="mt-4 text-lg text-teal-100/90">{t('login.heroEn')}</p>
        <p className="mt-6 max-w-md text-base leading-relaxed text-teal-50/70">{t('login.heroBody')}</p>
      </div>
      <div className="relative max-w-md rounded-2xl border border-white/10 bg-white/[0.06] p-5 backdrop-blur-md">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-amber-300">
          <PhoneCall className="h-4 w-4" />
          {t('login.sampleLabel')}
        </p>
        <p className="mt-3 text-lg leading-relaxed text-white" data-testid="login-sample-call">{t('login.sampleCall', { clinic, doctor })}</p>
      </div>
    </section>
  );
}
